import React from "react";
import styles from "./RadioButton.module.css";

export default function RadioButton({
                                        value,
                                        name,
                                        isChecked = false,
                                        onChange = () => {},
                                        label,
                                        option = null,
                                        renderDescription = null,
                                        className = ""
                                    }) {
    return (
        <label className={`${styles.radioOption} ${className}`}>
            <input
                type="radio"
                name={name}
                value={value}
                checked={isChecked}
                onChange={() => onChange(option ?? value)}
                className={styles.radioInput}
            />
            <p className="body capital">
                {label}
                {renderDescription && (
                    <span className={styles.date}>
                        {renderDescription(option ?? value)}
                    </span>
                )}
            </p>
        </label>
    );
}
